module.exports = __webpack_public_path__ + "d7370967daa76cfb25011ba06a79da05.ttf";